export default __webpack_public_path__ + "img/aciqui_logo.546f5bd5.svg";